var _path, _path2, _g, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConfirmedMarkSmall(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 32c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C8.716 2 2 8.716 2 17c0 8.284 6.716 15 15 15z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 33c8.837 0 16-7.163 16-16S25.837 1 17 1 1 8.163 1 17s7.163 16 16 16z",
    stroke: "#000",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#confirmed-mark-small_svg__clip0_325_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.123 11.683V23.26c0 .872-.678 1.579-1.515 1.579h-9.093c-.837 0-1.515-.707-1.515-1.579V11.683c0-.871.678-1.578 1.515-1.578h2.526c0-1.16.906-2.105 2.02-2.105 1.115 0 2.021.944 2.021 2.105h2.526c.837 0 1.515.707 1.515 1.578zm-6.061-2.368c-.419 0-.758.354-.758.79 0 .436.34.789.758.789s.757-.353.757-.79c0-.435-.339-.789-.757-.789zm3.03 3.75v-.658a.201.201 0 00-.055-.14.186.186 0 00-.134-.057H14.22c-.05 0-.098.02-.134.057a.202.202 0 00-.055.14v.658c0 .052.02.102.055.14a.186.186 0 00.134.057h5.683c.05 0 .099-.02.134-.058a.201.201 0 00.056-.14z",
    fill: "#2A848E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.816 11.507a.552.552 0 00-.78.046l-3.675 4.133-1.692-1.578a.555.555 0 00-.847.702l1.846 2.918a.904.904 0 001.514.022l3.724-5.522a.551.551 0 00-.09-.72",
    fill: "#FFD31A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "confirmed-mark-small_svg__clip0_325_127"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(11 8)",
    d: "M0 0h12.123v16.838H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedMarkSmall);
export default ForwardRef;